export default __webpack_public_path__ + "static/media/ticket.f290d2c9.png";